import { USER_ROLES } from './index';
import { getPortalTokens } from '../styles/portalTheme';
import { PARTNER_STATUS_VALUES } from '../utils/partnerStatus';

/** Backend `data.type` values for portal partner admin notifications. */
export const PARTNER_NOTIFICATION_TYPE = {
  PARTNER_ONBOARDING_SUBMITTED: 'partner_onboarding_submitted',
};

export const PARTNER_PROFILE_TARGET_TYPE = 'partner_profile';

export const PARTNER_MANAGEMENT_PENDING_PATH = `/partner-management?status=${PARTNER_STATUS_VALUES.PENDING}`;

export const PARTNER_NOTIFICATION_CATALOG = {
  [PARTNER_NOTIFICATION_TYPE.PARTNER_ONBOARDING_SUBMITTED]: {
    recipientRole: USER_ROLES.ADMIN,
    actorRole: null,
    label: 'New Partner Request',
    accentColor: getPortalTokens('light').accent,
    defaultMessage: 'A new partner website submission needs review',
  },
};

const normalizeTypeKey = (type) =>
  String(type || '')
    .trim()
    .toLowerCase();

export const getPartnerNotificationMeta = (type) => {
  const key = normalizeTypeKey(type);
  return PARTNER_NOTIFICATION_CATALOG[key] ?? null;
};

export const isPartnerNotificationForRole = (type, userRole) => {
  const key = normalizeTypeKey(type);
  const meta = getPartnerNotificationMeta(key);
  if (meta) {
    return meta.recipientRole === userRole;
  }
  if (key === PARTNER_PROFILE_TARGET_TYPE) {
    return userRole === USER_ROLES.ADMIN;
  }
  return false;
};

/** Deep link for push click / inbox row. */
export const resolvePartnerNotificationPath = ({ type, viewerRole }) => {
  if (viewerRole !== USER_ROLES.ADMIN) {
    return '/partner-notifications';
  }

  const normalizedType = normalizeTypeKey(type);
  if (
    normalizedType === PARTNER_NOTIFICATION_TYPE.PARTNER_ONBOARDING_SUBMITTED ||
    normalizedType === PARTNER_PROFILE_TARGET_TYPE
  ) {
    return PARTNER_MANAGEMENT_PENDING_PATH;
  }

  return PARTNER_MANAGEMENT_PENDING_PATH;
};
